import {
    ButtonType, ButtonWidget,
    InteractionState,
} from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

import { BroadcastViewDetailDialog } from './BroadcastViewDetailDialog';


export class BroadcastButton extends React.PureComponent<BroadcastButtonProps, BroadcastButtonStates> {

    constructor(props: BroadcastButtonProps) {
        super(props);
        this.state = { showingDialog: false };
    }

    public render() {
        return (
            <div>
                <ButtonWidget
                    buttonType={ButtonType.IconOutline}
                    style={{ cursor: 'pointer' }}
                    testId='broadcast-icon'
                    getContent={this.buttonContent}
                    handleClick={this.toggleDialogVisibility}
                />
                {this.state.showingDialog && this.getBroadcastViewDetailDialog()}
            </div>
        );
    }

    private buttonContent = (interactionState: InteractionState): JSX.Element => {
        const iconPath = `spaces_viz_view_header_cb.svg`;
        const backgroundColor = { backgroundColor: (interactionState.hover ? '#ebebeb' : 'transparent') };
        return (
            <span className={PageHeaderStyles.TextButton} style={backgroundColor}>
                <img src={imgPath(iconPath)}
                    style={PageHeaderStyles.iconOnlyButton}
                    alt="" />
            </span>
        );
    };

    private toggleDialogVisibility = () => {
        this.setState((prev) => {
            return { showingDialog: !prev.showingDialog };
        });
    };

    private hideDialog = () => {
        this.setState({ showingDialog: false });
    };

    private getBroadcastViewDetailDialog = () => {
        return (<BroadcastViewDetailDialog
            viewLuid={this.props.viewLuid}
            onCreateBroadcast={this.props.onCreateBroadcast}
            onDeleteBroadcast={this.props.onDeleteBroadcast}
            onCloseRequest={this.hideDialog} />);
    };
}

export interface BroadcastButtonProps {
    readonly viewLuid: string;
    onCreateBroadcast: () => void;
    onDeleteBroadcast: () => void;
}

export interface BroadcastButtonStates {
    readonly showingDialog: boolean;
}